import { render, staticRenderFns } from "./EtsyProductVariants.vue?vue&type=template&id=018ff04b&scoped=true&"
import script from "./EtsyProductVariants.vue?vue&type=script&lang=js&"
export * from "./EtsyProductVariants.vue?vue&type=script&lang=js&"
import style0 from "./EtsyProductVariants.vue?vue&type=style&index=0&id=018ff04b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018ff04b",
  null
  
)

export default component.exports